require('./js/api');

require('./js/colorize');

require('./js/form');

require('./js/state');

require('./js/visibility');

require('./js/visit');

require('./js/site');

require('./js/accordion');

require('./js/checkbox');

require('./js/dimmer');

require('./js/dropdown');

require('./js/embed');

require('./js/modal');

require('./js/nag');

require('./js/popup');

require('./js/progress');

require('./js/rating');

require('./js/search');

require('./js/shape');

require('./js/sidebar');

require('./js/sticky');

require('./js/tab');

require('./js/transition');